import Vue from 'vue';
import VueRouter from 'vue-router'
import store from 'src/store'

// Use router
Vue.use(VueRouter)

// Views
import * as Components from './templates/views'

// Dynamic Routes from Craft
const dynamicRoutes = window.__initialData__.routes.map(r => ({ ...r, component: Components[r.component] }));
const baseUrl = '/'
// Use the following for multi-site setup
//const baseUrl = store.state.global.site.baseUrl

// Priority routes
const priorityRoutes = [
    {
        name: 'Services',
        path: '/pages/services',
        redirect: '/pages/services/accompagnement-et-service-conseil'
    }
]

// Static routes
const staticRoutes = [
    {
        name: 'Error404',
        path: '*',
        redirect: '/'
    }
]

// Merge dynamic and static routes
const routes = [...priorityRoutes, ...dynamicRoutes, ...staticRoutes]

// Create the router with the routes
const router = new VueRouter({
    mode: 'history',
    base: baseUrl,
    routes,
    linkActiveClass: 'is-active',
    scrollBehavior(to, from, savedPosition) {

        const sameRoute = from.name === to.name && from.params.slug === to.params.slug

        if (sameRoute && !to.hash)
            return savedPosition;

        if (to.hash) {
            return { selector: to.hash }
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 }
        }
    }
})

// Before each route load
router.beforeEach((to, from, next) => {

    // Avoid loader on Blog filters
    const sameRoute = from.name === to.name && from.params.slug === to.params.slug

    if (!sameRoute) {

        store
            .dispatch('global/loadContent', to)
            .then(next)

    } else {

        next()
    }
})

// Link resolver
const linkResolver = section => {

    const route = routes.find(route => route.meta && route.meta.section === section)

    if(route) {
        return route.path
    } else {
        return '/'
    }
}

// Export
export default router
export { router, routes, linkResolver }
